<template>
  <cs-preloader-overlay :loading="loading">
    <template v-if="isProjectLoaded">
      <marketplace-bills
        v-if="hasMarketplaceBills"
        :project="PROJECT"
        @donate="handlePaymentFormShown"
      />
      <payment-amount
        v-else
        :project="PROJECT"
      />
    </template>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import MarketplaceBills from './project/MarketplaceBills';
import PaymentAmount from './project/PaymentAmount';

import { parseURL } from './helper';

const PAYMENT_PARAMETERS = ['amount', 'tipPercents'];
const INFORMATION_PARAMETERS = ['description'];
const REQUIRED_PARAMETERS = ['phone', 'email'];
const SINGLES_PARAMETERS = ['comment', 'message', 'address'];
const SENDER_PARAMETERS = ['name', ...REQUIRED_PARAMETERS, ...SINGLES_PARAMETERS];
const TECHNIC_PARAMETERS = ['readonly', 'istest'];
const TILDA_PARAMETERS = ['action', 'orderId'];
const YANDEX_PAYMENT = ['__YP__'];

const FULL_PARAMETERS = [
  ...PAYMENT_PARAMETERS,
  ...INFORMATION_PARAMETERS,
  ...SENDER_PARAMETERS,
  ...TECHNIC_PARAMETERS,
  ...TILDA_PARAMETERS,
  ...YANDEX_PAYMENT,
];

export default {
  name: 'PaymentProject',
  components: {
    MarketplaceBills,
    PaymentAmount,
  },
  created() {
    this.loadProject();
  },
  data() {
    return {
      loading: false,
      isPaymentFormShown: false,
    };
  },
  computed: {
    projectCode() {
      return this.$route.params.id;
    },
    isProjectLoaded() {
      return this.$validate.isNotEmptyObject(this.PROJECT);
    },
    hasMarketplaceBills() {
      const { hasMarketplaceBills, widgets } = this.PROJECT;

      return (hasMarketplaceBills || this.$validate.isNotEmptyArray(widgets)) && !this.isPaymentFormShown;
    },
    hasProjectInactiveStatus() {
      const { status } = this.PROJECT;

      return status && status === 'INACTIVE';
    },
    ...mapState(['PROJECT']),
  },
  methods: {
    async loadProject() {
      this.loading = true;

      if (this.$validate.isUndefined(this.projectCode)) {
        this.$router.push({ name: 'project.blocked' });
        return;
      }

      try {
        await this.GET_PROJECT(this.projectCode);
        await this.GET_PROJECT_LOCALE({ projectCode: this.projectCode });

        if (this.hasProjectInactiveStatus) {
          this.$router.push({ name: 'project.blocked' });
          return;
        }

        this.parseUrl();
      } catch (error) {
        this.$router.push({ name: 'service.error' });
      } finally {
        this.loading = false;
      }
    },
    parseUrl() {
      const urlParameters = parseURL(FULL_PARAMETERS, [...PAYMENT_PARAMETERS, ...SENDER_PARAMETERS]);
      const isYandexPaymentProcessing = this.$validate.isObjectWithFields(this.$route.query, ['__YP__']);
      console.log('ROUTE::QUERY', this.$route.query);
      console.log('isYandexPaymentProcessing', isYandexPaymentProcessing);
      this.isPaymentFormShown = this.$validate.isNotEmptyObject(urlParameters) || isYandexPaymentProcessing;
    },
    handlePaymentFormShown() {
      this.isPaymentFormShown = true;
    },
    ...mapActions(['GET_PROJECT', 'GET_PROJECT_LOCALE']),
  },
};
</script>
